import axios from 'axios';

/**
 * Fetches and caches user info
 * @param {boolean} forceRefresh - Force refresh even if data exists in session
 */
export const fetchAndCacheUserInfo = async (forceRefresh = false) => {
  const jwtToken = sessionStorage.getItem("jwtToken");

  if (!jwtToken) {
    console.error("JWT токен не найден");
    throw new Error("No JWT token");
  }

  if (!forceRefresh && sessionStorage.getItem("balance")) {
    console.log("User data already cached, skipping fetch");
    return Promise.resolve();
  }

  try {
    const response = await axios.post(
      "https://baaack.zabanishumresh.com/requestGetAllUserInfoWithTasks",
      {},
      {
        headers: {
          Authorization: `${jwtToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    const userInfo = response.data;

    sessionStorage.setItem("balance", userInfo.balance);
    sessionStorage.setItem("subscription_link", userInfo.subscription_link);
    sessionStorage.setItem("link_state", userInfo.link_state);
    sessionStorage.setItem("history_payments", userInfo.history_payments);
    sessionStorage.setItem("referral_link", userInfo.referral_link);
    sessionStorage.setItem("referrals", userInfo.referrals);
    sessionStorage.setItem("task", JSON.stringify([...userInfo.task]));

    // ✅ Сохраняем first_login
    if (userInfo.first_login !== undefined) {
      sessionStorage.setItem("first_login", userInfo.first_login);
    }

    // ✅ Сохраняем сертификаты
    if (userInfo.my_certs && Array.isArray(userInfo.my_certs)) {
      sessionStorage.setItem("my_certs", JSON.stringify(userInfo.my_certs));
      console.log(`✅ Saved ${userInfo.my_certs.length} certificates to session storage`);
    } else {
      // Если сертификатов нет, сохраняем пустой массив
      sessionStorage.setItem("my_certs", JSON.stringify([]));
      console.log("✅ No certificates found, saved empty array");
    }

    // ✅ Сохраняем white_list
    if (userInfo.white_list) {
      sessionStorage.setItem("white_list", JSON.stringify(userInfo.white_list));
      console.log("✅ White list data saved:", userInfo.white_list);
    } else {
      // Если данных нет, сохраняем null или дефолтные значения
      sessionStorage.setItem("white_list", JSON.stringify({
        gb_left: 0,
        total_purchased: 0,
        first_bonus_given: false,
        subscription_link: null
      }));
      console.log("✅ No white_list data, saved default values");
    }

    // ✅ Парсим remna_links если они есть
    let remnaLinks = {};
    if (userInfo.remna_links) {
      try {
        remnaLinks = typeof userInfo.remna_links === 'string'
          ? JSON.parse(userInfo.remna_links)
          : userInfo.remna_links;
        console.log("✅ Remna links parsed:", remnaLinks);
      } catch (error) {
        console.error("❌ Error parsing remna_links:", error);
      }
    }

    sessionStorage.removeItem('subscription_link_basic');
    sessionStorage.removeItem('subscription_link_medium');
    sessionStorage.removeItem('subscription_link_premium');
    sessionStorage.removeItem('freeSubscriptionLink');
    sessionStorage.removeItem('tariff_expiry_basic');
    sessionStorage.removeItem('tariff_expiry_medium');
    sessionStorage.removeItem('tariff_expiry_premium');
    sessionStorage.removeItem('tariff_expiry_free');

    if (userInfo.unique_tariffs) {
      userInfo.unique_tariffs.forEach(tariff => {
        const nameLower = tariff.name.toLowerCase();
        if (nameLower.includes("basic")) {
          // ✅ Приоритет remna_links над обычными ссылками
          const link = remnaLinks.Basic || tariff.subscription_link;
          sessionStorage.setItem("subscription_link_basic", link);
          sessionStorage.setItem("tariff_expiry_basic", tariff.expiry);
        } else if (nameLower.includes("medium")) {
          const link = remnaLinks.Medium || tariff.subscription_link;
          sessionStorage.setItem("subscription_link_medium", link);
          sessionStorage.setItem("tariff_expiry_medium", tariff.expiry);
        } else if (nameLower.includes("premium")) {
          const link = remnaLinks.Premium || tariff.subscription_link;
          sessionStorage.setItem("subscription_link_premium", link);
          sessionStorage.setItem("tariff_expiry_premium", tariff.expiry);
        }
      });
    }

    if (userInfo.free_tariff && userInfo.free_tariff !== "0") {
      try {
        const parsedFreeTariff = JSON.parse(userInfo.free_tariff);
        // ✅ Приоритет remna_links над обычными ссылками для Free тарифа
        const link = remnaLinks.Free || parsedFreeTariff.subscription_link;
        if (link) {
          sessionStorage.setItem("free_subscription_link", link);
        }
        if (parsedFreeTariff.tariff_left) {
          const parts = parsedFreeTariff.tariff_left.split(' ');
          const daysLeft = parseInt(parts[0], 10) || 0;
          const hoursLeft = parseInt(parts[2], 10) || 0;
          const expiryTimestamp = Math.floor(Date.now() / 1000) + (daysLeft * 86400) + (hoursLeft * 3600);
          sessionStorage.setItem("tariff_expiry_free", expiryTimestamp.toString());
        }
      } catch (error) {
        console.error("Error parsing free tariff:", error);
      }
    }

    const tariffsData = {
      basic: {
        link: sessionStorage.getItem('subscription_link_basic'),
        expiry: sessionStorage.getItem('tariff_expiry_basic')
      },
      medium: {
        link: sessionStorage.getItem('subscription_link_medium'),
        expiry: sessionStorage.getItem('tariff_expiry_medium')
      },
      premium: {
        link: sessionStorage.getItem('subscription_link_premium'),
        expiry: sessionStorage.getItem('tariff_expiry_premium')
      },
      free: {
        link: sessionStorage.getItem('free_subscription_link'),
        expiry: sessionStorage.getItem('tariff_expiry_free')
      }
    };

    sessionStorage.setItem('all_tariffs', JSON.stringify(tariffsData));
    sessionStorage.setItem("tarifsLoaded", "true");
    sessionStorage.setItem("tarifsLoadedTime", Date.now().toString());

    console.log("User info successfully cached");
    return userInfo;

  } catch (error) {
    console.error("Ошибка при запросе информации о пользователе:", error);
    throw error;
  }
};